/**
 *
 * @param { value: valueToValidate, message: 'CustomErrorMessage' } opts
 * @returns { valid: true/false, messages: Array}
 */
export default class ListItemValidator {
	constructor(opts) {
		this.validateOn = 'change';

		if (opts) {
			this.customMessage = opts.message;

			if (opts.validateOn) {
				this.validateOn = opts.validateOn;
			}
		}

		this.defaultMessage = 'Please select a value from the list.';
		this.result = { valid: true };
	}

	validate(value, options) {
		let matchedItemIndex;
		const self = this;

		this.result.valid = true;
		this.value = value;
		this.options = options;

		if (this.options && Array.isArray(this.options)) {
			matchedItemIndex = this.options.findIndex(
				o => o.value == self.value
			);

			if (matchedItemIndex < 0) {
				this.result.valid = false;
			}
		}

		if (!this.result.valid) {
			if (this.customMessage) {
				this.result.messages = [this.customMessage];
			} else {
				this.result.messages = [this.defaultMessage];
			}
		}

		return this.result;
	}
}
